import StorageService from './storage.service';
import JPMCService from './jpmc.service';
import UserDataService from './userData.service';
import ResultsService from './results.service';
import GeolocationService from './geolocation.service';
import GoogleMapService from './googlemap.service';
import AnchorSmoothScroll from './anchorSmoothScroll.service';

let ServicesModule = angular.module('app.services', [])
  .service('StorageService', StorageService)
  .service('JPMCService', JPMCService)
  .service('UserDataService', UserDataService)
  .service('ResultsService', ResultsService)
  .service('GeolocationService', GeolocationService)
  .service('GoogleMapService', GoogleMapService)
  .service('AnchorSmoothScroll', AnchorSmoothScroll);

export default ServicesModule;



// WEBPACK FOOTER //
// ./src/services/services.js